import { c as _c } from "react/compiler-runtime";
import type React from 'react';
export function OILogo(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g transform="matrix(.04032 0 0 -.04032 6.352 10.675)"><path d="M0 0h69.487l34.491-57.286L173.332 57.81 207.823 0h69.411l-34.483 57.81 34.483 56.062H138.842l34.49 59.092-34.49 57.369-34.864-57.369H34.92L103.978 57.81H34.92Z" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g transform="matrix(.04032 0 0 -.04032 .772 19.955)"><path d="M0 0h69.419l34.491-57.369L173.333 57.37 207.888 0h69.355l-34.864 57.37 34.864 57.805H138.401l34.932 57.731-34.932 57.288-34.491-57.288H34.492L103.91 57.37H34.492Z" /></g>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g transform="matrix(.04032 0 0 -.04032 11.95 19.955)"><path d="M0 0h68.981l34.928-57.369L172.883 57.37 207.823 0h69.047l-34.484 57.37 34.484 57.805H138.393l34.49 57.731-34.49 57.288-34.484-57.288H34.49L103.909 57.37H34.49Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg aria-hidden="true" {...props} className={props.className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}